<template>
  <!-- <div>
    <div class="content ">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small" v-preventReClick @click="handleAdd">新增</el-button>
          <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" size="small" :disabled="multiple" v-preventReClick @click="handleDelete">
            删除
          </el-button>
        </div>
        <div class="right">
          <div class="search">
            <input type="text" v-model="query.keyWord"  />
            <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i>
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>

      <el-table v-loading="loading" ref="multipleTable" :data="tableData" :max-height="tableHeight" row-key="id" :tree-props="{ children: 'children' }" style="width: 100%;margin-top:10px" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <el-table-column align="center" type="selection" fixed width="55">
        </el-table-column>
        <el-table-column prop="name" label="名称" min-width="180">
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="180">
        </el-table-column>
        <el-table-column prop="createdTime" label="创建时间" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ parseTime(new Date(scope.row.createdTime)) }}
          </template>
        </el-table-column>
        <el-table-column prop="operation" label="操作" show-overflow-tooltip width="110px">
          <template slot-scope="scope">
            <el-button v-if="tableAcl.indexOf('Edit') != -1" type="text" v-preventReClick @click="handleUpdate(scope.row)" class="color-blue">编辑</el-button>
            <el-button v-if="tableAcl.indexOf('Remove') != -1" type="text" class="margin-left20 color-blue" v-preventReClick @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog :title="title + '模块'" :visible.sync="open" :center="true" width="1100px" :before-close="cancel" :close-on-click-modal="false">
        <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
          <el-row>
            <el-col :span="12">
              <el-form-item label="名称" prop="name">
                <el-input v-model="form.name" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="上级分类" prop="parentId">
                <SelectTree @handleCheckChange="handleCheckChange" :defaultProps="defaultProps" :data="STATIC_ProductCategorys" :defaultValue="form.parentName" style="width:100%"></SelectTree>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="备注" prop="remark">
                <el-input v-model="form.remark" placeholder="请输入备注"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" style="">
          <el-button class="btn" size="small" v-preventReClick @click="cancel">取 消</el-button>
          <el-button class="btn primary" type="primary" size="small" v-preventReClick @click="submit">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
  </div> -->
  <Index :type="1" :isDrug="true"></Index>
</template>

<script>
import Index from '@/views/components/treeCategoryTable'
export default {
  components: {
    Index
  }
};
</script>